import { Reducer } from 'redux';

import { MarkAllNotificationsAsSeenFulfilledAction } from '../../domains/notificationFeeds/actions.types';
import {
  NotificationLoadMoreFulfilledAction,
  NotificationUnseenCountLoadFulfilledAction,
} from '../../domains/notificationPaginations/actions.types';

import { NotificationPaginations } from './types';

export type NotificationPaginationAction =
  | NotificationUnseenCountLoadFulfilledAction
  | NotificationLoadMoreFulfilledAction
  | MarkAllNotificationsAsSeenFulfilledAction;

const initialState: NotificationPaginations = {
  unseenCount: 0,
  hasPreviousPage: false,
  startCursor: null,
};

type UpdateNotificationUnseenCount = (state: NotificationPaginations, unseenCount: number) => NotificationPaginations;

const updateNotificationUnseenCount: UpdateNotificationUnseenCount = (state, unseenCount) => ({
  ...state,
  unseenCount,
});

type Update = (
  state: NotificationPaginations,
  payload: MarkAllNotificationsAsSeenFulfilledAction['payload'] | NotificationLoadMoreFulfilledAction['payload']
) => NotificationPaginations;
const update: Update = (_state, { pageInfo: { hasPreviousPage, startCursor }, unseenCount }) => ({
  unseenCount,
  hasPreviousPage,
  startCursor,
});

const reducer: Reducer<NotificationPaginations, NotificationPaginationAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NOTIFICATION_UNSEEN_COUNT.LOAD_FULFILLED':
      return updateNotificationUnseenCount(state, action.payload.unseenCount);
    case 'MARK_ALL_NOTIFICATIONS_AS_SEEN.LOAD_FULFILLED':
      return update(state, action.payload);
    case 'NOTIFICATION.LOAD_MORE_FULFILLED':
      return update(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
